import { WhitelistFromApi } from '@/services/whitelistsApi';
import { WhitelistFile } from '@/components/whitelist-management/types';

/**
 * Transform API response to component format
 */
export function transformWhitelistFromApi(
  apiData: WhitelistFromApi
): WhitelistFile {
  // Safely construct user name
  const firstName = apiData.user?.first_name || '';
  const lastName = apiData.user?.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const uploadedBy = fullName || apiData.user?.email || 'Unknown User';

  // Safely parse date
  let uploadDate: Date;
  try {
    uploadDate = new Date(apiData.created_at);
    // Check if date is valid
    if (isNaN(uploadDate.getTime())) {
      uploadDate = new Date();
    }
  } catch {
    uploadDate = new Date();
  }

  return {
    id: apiData.id,
    filename: apiData.filename || 'Unknown File',
    uploadedBy,
    uploadDate,
    isActive: false, // Will be determined by business logic
    size: apiData.size || 0,
    contentType: apiData.content_type || 'application/octet-stream',
    fileUrl: '', // deprecated - will be removed
    userId: apiData.user_id || '',
    lastVersionId: apiData.last_version_id || apiData.id, // fallback to id if last_version_id not available
  };
}

/**
 * Transform array of API responses to component format
 */
export function transformWhitelistsFromApi(
  apiData: WhitelistFromApi[]
): WhitelistFile[] {
  return apiData.map(transformWhitelistFromApi);
}

/**
 * Determine active whitelist (latest uploaded one for now)
 * In real implementation, this logic should come from backend
 */
export function determineActiveWhitelist(
  whitelists: WhitelistFile[]
): WhitelistFile[] {
  if (!whitelists || whitelists.length === 0) return [];

  // Sort by upload date (newest first) with safe date comparison
  const sorted = [...whitelists].sort((a, b) => {
    const dateA = a.uploadDate instanceof Date ? a.uploadDate.getTime() : 0;
    const dateB = b.uploadDate instanceof Date ? b.uploadDate.getTime() : 0;
    return dateB - dateA;
  });

  // Mark the newest one as active
  return sorted.map((file, index) => ({
    ...file,
    isActive: index === 0,
  }));
}
